konnyScript(function($){
  //KO71,KO72,KO191 아기띠 플렉스&힙시트 세트상품 오토 슬라이드
  /*스타일링 팁 슬라이드_25FW*/
  $('[id^=\'set_auto_swiper_slide\']').each(function(index){
    index = index+1;
    var slidePage1 = this.querySelector('.swiper-pagination');
    var slidePage2 = this.querySelector('.swiper-progress');
    var slideScr = this.querySelector('.swiper-scrollbar');
    var slideNext = this.querySelector('.swiper-button-next');
    var slidePrev = this.querySelector('.swiper-button-prev');
    var eventSwiper = new Swiper(this,{
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      spaceBetween: '2.9%',
      pagination:{
        el:slidePage1,
        clickable:true,
      },
      scrollbar:{
        el:slideScr,
        hide:true,
      },
      speed:2000,
      autoplay: {
        delay: 1000,
        disableOnInteraction: false,
      },
    });
  });
  

  /*스타일링 팁 슬라이드_25FW*/
  $('[id^=\'style_25fw_swiper_slide\']').each(function(index){
    index = index+1;
    var slidePage1 = this.querySelector('.swiper-pagination');
    var slidePage2 = this.querySelector('.swiper-progress');
    var slideScr = this.querySelector('.swiper-scrollbar');
    var slideNext = this.querySelector('.swiper-button-next');
    var slidePrev = this.querySelector('.swiper-button-prev');
    var style25fwSlide = new Swiper(this,{
        slidesPerView:'auto',
        slidesPerGroup:1,
        spaceBetween:'2.9%',
        centeredSlides:false,
        observer:true,
        observeParents:true,
        //loop: true,
        pagination:true,
        pagination:{
          el:slidePage1,
          clickable:true,
        },
        scrollbar:{
          el:slideScr,
          hide:true,
        },
    });
  });

  /*몰컷 슬라이드_25FW*/
  $('[id^=\'mall_25fw_swiper_slide\']').each(function(index){
    index = index+1;
    var slidePage1 = this.querySelector('.swiper-pagination');
    var slidePage2 = this.querySelector('.swiper-progress');
    var slideScr = this.querySelector('.swiper-scrollbar');
    var slideNext = this.querySelector('.swiper-button-next');
    var slidePrev = this.querySelector('.swiper-button-prev');
    var style25fwSlide = new Swiper(this,{
        slidesPerView:'auto',
        slidesPerGroup:1,
        spaceBetween:'2.9%',
        centeredSlides:false,
        observer:true,
        observeParents:true,
        //loop: true,
        pagination:true,
        pagination:{
          el:slidePage1,
          clickable:true,
        },
        scrollbar:{
          el:slideScr,
          hide:true,
        },
    });
  });
  
  var styletipSlide = new Swiper('#styletip_swiper_slide1',{
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      spaceBetween: 10,
      //loop: true,
      scrollbar: {
          el: '#styletip_swiper_slide1 .swiper-scrollbar',
      },
      pagination: {
          el: '#styletip_swiper_slide1 .swiper-pagination',
      },
      navigation: {
          nextEl: '#styletip_swiper_slide1 .swiper-button-next',
          prevEl: '#styletip_swiper_slide1 .swiper-button-prev',
      },
  });
    
  var styletipSlide = new Swiper('#styletip_swiper_slide1',{
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      spaceBetween: 10,
      //loop: true,
      scrollbar: {
          el: '#styletip_swiper_slide1 .swiper-scrollbar',
      },
      pagination: {
          el: '#styletip_swiper_slide1 .swiper-pagination',
      },
      navigation: {
          nextEl: '#styletip_swiper_slide1 .swiper-button-next',
          prevEl: '#styletip_swiper_slide1 .swiper-button-prev',
      },
  });
  
  var sTipSlide = new Swiper('#sTip_swiper_slide1',{
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    spaceBetween: 10,
    //loop: true,
    scrollbar: {
      el: '#sTip_swiper_slide1 .swiper-scrollbar',
    },
    pagination: {
      el: '#sTip_swiper_slide1 .swiper-pagination',
    },
    navigation: {
      nextEl: '#sTip_swiper_slide1 .swiper-button-next',
      prevEl: '#sTip_swiper_slide1 .swiper-button-prev',
    },
  });
  
  var spcSlide = new Swiper('#spc_swiper_slide1',{
    centeredSlides: true,
    speed:0,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    pagination:true,
    pagination:{
      el:'#spc_swiper_slide1 .swiper-pagination',
        clickable:true,
    },
    scrollbar:{
      el:'#spc_swiper_slide1 .swiper-scrollbar',
      hide:true,
    },
  });
  
  $('[id^=\'mall_swiper_slide\']').each(function(index){
      index = index+1;
      var slideScr = this.querySelector('.swiper-scrollbar');
      var mallSlide = new Swiper(this,{
          slidesPerView:1.19,
          slidesPerGroup:1,
          spaceBetween:'3%',
          centeredSlides:true,
          scrollbar:{
              el:slideScr,
              hide:true,
          },
      });
  });

  $('#k-prdWrap [id^=\'w_swiper_slide\']').each(function(index){
      index = index+1;
      var slideScr = this.querySelector('.swiper-scrollbar');
      var mallSlide = new Swiper(this,{
          slidesPerView:1,
          slidesPerGroup:1,
          centeredSlides:true,
          scrollbar:{
              el:slideScr,
              hide:true,
          },
      });
  });
    
  $('#k-prdWrap .conInfoWrap .conTop').click(function(){
    var onDiv = $(this).parents('.conInfoWrap');
    onDiv.toggleClass('on');
  });
  
  $('[id^=\'gif_swiper_slide\']').each(function(index){
    index = index+1;
    var slidePage1 = this.querySelector('.swiper-pagination');
    var slidePage2 = this.querySelector('.swiper-progress');
    var slideScr = this.querySelector('.swiper-scrollbar');
    var slideNext = this.querySelector('.swiper-button-next');
    var slidePrev = this.querySelector('.swiper-button-prev');
    var gifSlide = new Swiper(this,{
      slidesPerView:1,
      slidesPerGroup:1,
      centeredSlides:true,
      loop:true,
      effect:'fade',
      speed:300,
      autoplay:{
        delay:700,
        disableOnInteraction:false,
      },
    });
  });
  
  
  $('[id^=\'gif_swiperslide\']').each(function(index){
      var gifSlide = new Swiper(this,{
          slidesPerView:1,
          slidesPerGroup:1,
          centeredSlides:true,
          loop:true,
          effect:'fade',
          speed:0,
          autoplay:{
              delay:700,
              disableOnInteraction:false,
          },
      });
  });
    
  
  //전체싱품보기
  var allprdSlide = new Swiper('#allprd_swiper_slide',{
      slidesPerView:2.1,
      slidesPerGroup:1,
      spaceBetween:15,
      centeredSlides:false,
      observer:true,
      observeParents:true,
      //loop:true,
  });
  
  /* 뉴컬러 화보 슬라이드 */
  $('[id^=\'nc_swiper_slide\']').each(function(index){
    index = index+1;
    var slidePage1 = this.querySelector('.swiper-pagination');
    var slidePage2 = this.querySelector('.swiper-progress');
    var slideScr = this.querySelector('.swiper-scrollbar');
    var slideNext = this.querySelector('.swiper-button-next');
    var slidePrev = this.querySelector('.swiper-button-prev');
    var reviewSlide = new Swiper(this,{
      slidesPerView:1.19,
      slidesPerGroup:1,
      spaceBetween :'3%',
      centeredSlides:true,
      observer:true,
      observeParents:true,
      //loop: true,
      pagination:true,
      pagination:{
        el:slidePage1,
        clickable:true,
      },
      scrollbar:{
        el:slideScr,
        hide:true,
      },
    });
  });

    // ── 세트상품 이미지 ↔ 텍스트 슬라이드 연동 ──────────────────────────
    $(".setImgSlide").each(function () {
        var $imgEl = $(this);
        var $wrap = $imgEl.closest(".prdWrap");
        var $txtEl = $wrap.length ? $wrap.find(".setTxtSlide") : $imgEl.siblings(".setTxtSlide");

        if (!$imgEl.length || !$txtEl.length) {
            return; // 짝이 되는 요소가 없으면 건너뜀
        }

        var imgEl = $imgEl.get(0);
        var txtEl = $txtEl.get(0);

        var topNum = $imgEl.find(".swiper-slide");
        var subNum = $txtEl.find(".gallery-thumbs");

        var galleryTop = new Swiper(imgEl, {
            slidesPerView: "auto",
            slidesPerGroup: 1,
            spaceBetween: 10,
            observer: true,
            observeParents: true,
            pagination: {
                el: imgEl.querySelector(".swiper-pagination"),
                clickable: true,
                type: "bullets",
                renderBullet: function (idx, className) {
                    return '<span class="' + className + '">' + (idx + 1) + "</span>";
                }
            },
            scrollbar: { el: imgEl.querySelector(".swiper-scrollbar") },
            loop: false,
            loopedSlides: topNum.length
        });

        var galleryThumbs = new Swiper(txtEl, {
            slidesPerView: 1,
            slidesPerGroup: 1,
            effect: "fade",
            observer: true,
            observeParents: true,
            navigation: {
                nextEl: txtEl.querySelector(".swiper-button-next"),
                prevEl: txtEl.querySelector(".swiper-button-prev")
            },
            centeredSlides: true,
            touchRatio: 0.2,
            slideToClickedSlide: true,
            loop: false,
            loopedSlides: subNum.length
        });

        // 컨트롤러 모듈이 정상적으로 붙어있을 때만 연동 (하나가 깨져도 전체가 멈추지 않도록 방어)
        if (galleryTop.controller && galleryThumbs.controller) {
            galleryTop.controller.control = galleryThumbs;
            galleryThumbs.controller.control = galleryTop;
        } else {
            console.warn("[세트 슬라이드 연동 실패]", imgEl.id || imgEl, txtEl.id || txtEl);
        }
    });
  
});